import React from 'react';
import { Spinner } from './Spinner';
var FULL_SCREEN_CLASS = 'h-screen w-screen flex';
export var FullScreen = function () { return (React.createElement("div", { className: FULL_SCREEN_CLASS },
    React.createElement(Spinner, { size: "4x", className: "m-auto" }))); };
